// extracted by mini-css-extract-plugin
module.exports = {"blogLayout":"layout-module--blog-layout--3UW8U","header":"layout-module--header--AZ5He","title":"layout-module--title--36F1v"};